import {ChevronDownIcon} from "@heroicons/react/solid";
import React, {Fragment, useEffect, useState} from "react";
import {Menu, Transition} from "@headlessui/react";
import FloatingDropdownItem from "./FloatingDropdownItem";
import {useUniqueId} from "../../hooks/useUniqueId";
import Spinner from "../Spinner";

export type Item = {
  label: string
  value: any
}

type FloatingDropdownProps = {
  label?: string
  items: Array<Item>
  selectedIndex?: number
  onSelect: (item: Item) => void
  loading?: boolean
}

function FloatingDropdown({label, items, selectedIndex = 0, onSelect, loading}: FloatingDropdownProps) {
  const [selectedItem, setSelectedItem] = useState<Item>(items[selectedIndex])
  const id = useUniqueId();

  useEffect(() => {
    setSelectedItem(items[selectedIndex])
  }, [selectedIndex, items]);

  function handlePress(item: Item) {
    setSelectedItem(item)
    onSelect?.(item)
  }

  return (
    <Menu as="div" className="relative">
      {label ? <label htmlFor={id} className='text-gray-500 text-sm'>{label}</label> : null}

      <Menu.Button
        id={id}
        type="button"
        className="flex min-h-[38px] leading-tight items-center gap-x-2 rounded-md bg-white px-3 py-2 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-brand"
      >
        {loading && <Spinner size={Spinner.sizes.X_SMALL} color={Spinner.colors.NEUTRAL}/>}
        {selectedItem?.label}
        <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-50 mt-3 w-36 origin-top-right max-h-96 overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {items.map((item, index) => (
              <FloatingDropdownItem label={item.label} onPress={() => handlePress(item)} key={index}/>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default FloatingDropdown